/* eslint-disable */
/**
 * 返回uid
 * @return {string} uid字符串
 */
function getRandomUid() {
    let tn = new Date().getTime() + (Math.round((1 << 12) * Math.random()) << 24);
    const sn = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZXX';
    let uuid = '';

    const fn1 = sn.charAt(parseInt(tn & 63));

    tn >>= 6;
    const fn2 = sn.charAt(parseInt(tn & 63));

    tn >>= 6;
    const fn3 = sn.charAt(parseInt(tn & 63));

    tn >>= 6;
    const fn4 = sn.charAt(parseInt(tn & 63));

    tn >>= 6;
    const fn5 = sn.charAt(parseInt(tn & 63));

    tn >>= 6;
    const fn6 = sn.charAt(parseInt(tn & 63));

    uuid += fn6 + fn5 + fn4 + fn3 + fn2 + fn1;

    return uuid;
}

export default getRandomUid;



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.component.util/app/lib/auth/utils/uid.js